// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IBrWI{color:#ed4f9d;font-size:16px;font-weight:500;padding:12px;background-color:#fef2f2;border:1px solid #fecaca;border-radius:8px;font-family:"Inter",sans-serif}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `IBrWI`
};
module.exports = ___CSS_LOADER_EXPORT___;
